import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { bsc, bscTestnet } from "wagmi/chains";
export const config = getDefaultConfig({
  appName: "RainbowKit App",
  // projectId: "e731e6939e5decd2eb8075e801eaa267",
  projectId: "YOUR_PROJECT_ID",
  chains: [
    process.env.REACT_APP_REACT_APP_NETWORK === "mainnet" ? bsc : bscTestnet,
  ],
  ssr: true,
});
